export default "__VITE_ASSET__or08ulF4__"